export default "__VITE_ASSET__ba355ce8__"